import { useHistory } from 'react-router-dom';

export const useUpdateQueryParams = () => {
  const history = useHistory();

  return (paramsToUpdate = {}) => {
    const searchParams = new URLSearchParams(history.location.search);

    Object.entries(paramsToUpdate).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        searchParams.delete(key); // Remove param
      } else {
        searchParams.set(key, value); // Add/update param
      }
    });

    history.replace({
      pathname: history.location.pathname,
      search: `?${searchParams.toString()}`,
    });
  };
};
